/* eslint-disable @typescript-eslint/strict-boolean-expressions */
import { tracked } from '@glimmer/tracking';
import Controller from '@ember/controller';
import TaxRateModel from 'cio/models/tax-rate';
import { alias } from '@ember/object/computed';
import CouponModel from 'cio/models/coupon';
import BillingService from 'cio/services/billing';
import { inject as service } from '@ember/service';
import RouterService from '@ember/routing/router-service';
import AccountService from 'cio/services/account';
import AlertsService from 'cio/services/alerts';
import MomentService from 'cio/services/moment';
import DS from 'ember-data';
import FeaturesService from 'ember-feature-flags/services/features';
import { Plans } from 'cio/utils/billing/plans';
import { task } from 'ember-concurrency';
import { PlanType } from 'cio/models/plan';

export default class CheckoutController extends Controller {
  @service billing!: BillingService;
  @service account!: AccountService;
  @service alerts!: AlertsService;
  @service router!: RouterService;
  @service moment!: MomentService;
  @service features!: FeaturesService;
  @service store!: DS.Store;

  queryParams = ['plan', 'code', 'suspended', 'reactivated', 'updatedCard'];

  // string or null, initializing to null to avoid this.router.transitionTo setting an empty URL query param:
  @tracked plan: string | null = null;
  @tracked code: string | null = null;

  @alias('billing.coupon') coupon!: CouponModel;

  @tracked showEssentialsPlanSignupForm = true;
  @tracked showCheckout = true;

  taxRate?: TaxRateModel;

  get planForCheckout() {
    if (this.billing.pinnedPlan?.planType === PlanType.Startup) {
      switch (this.billing.pinnedPlan?.slug) {
        case Plans.StartupEssentials.slug:
          return Plans.StartupEssentials;
        case Plans.StartupBasic.slug:
          return Plans.StartupBasic;
        case Plans.StartupPlus.slug:
          return Plans.StartupPlus;
        default:
          return Plans.StartupEssentials;
      }
    } else {
      switch (this.billing.pinnedPlan?.planType) {
        case Plans.Essentials.planType:
          return Plans.Essentials;
        case Plans.Premium.planType:
          return Plans.Premium;
        case Plans.Enterprise.planType:
          return Plans.Enterprise;
        case Plans.CdpPremium.planType:
          return Plans.CdpPremium;
        default:
          return Plans.Essentials;
      }
    }
  }

  startSubscription = task({ drop: true }, async ({ setupIntent }: { setupIntent: Record<string, any> }) => {
    this.billing.startSubscription.perform({ setupIntent }, this.code);
  });
}
